import loginPageHeaderImg from '../../2022-component-library/src/temp-imgs/african-american-doctor-writing-medical-record-in-2021-09-02-07-15-21-utc 1.jpg';
import { Image, Icon, Flex, Button, Input } from '../../2022-component-library';
import { passwordLock, emailEnvelope, rebrandedIbisVisionLogo } from '../../2022-component-library/src/icons';
import { useMediaQuery } from '../../helpers/useMediaQuery';
import { useAuth } from '../../context/authContext';
import { useState } from 'react';
import styled from '@emotion/styled';
import { useParams } from 'react-router-dom';

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ResponsiveLogin = () => {
  const isLandscapeView = useMediaQuery('(orientation: landscape)');
  const smallScreen = useMediaQuery('(max-width: 700px)');
  const [user, setUser] = useState();
  const { login } = useAuth();
  const params = useParams();
  localStorage.setItem('room_name', params.roomName);

  return (
    <Flex column height='100vh' overflow='hidden'>
      {(!isLandscapeView || !smallScreen) && <Image src={loginPageHeaderImg} width='100%' height='auto' />}
      <Flex
        column
        alignItems='center'
        backgroundColor='#fff'
        width='100vw'
        borderTopLeftRadius='25px'
        borderTopRightRadius='25px'
        height={isLandscapeView && smallScreen ? '100vh' : '65vh'}
        position='absolute'
        left='0'
        bottom='0'
      >
        <Icon icon={rebrandedIbisVisionLogo} margin='0.5rem' width='200px' />
        <LoginForm
          onSubmit={(e) => {
            e.preventDefault();
            login(user);
          }}
        >
          <Input
            icon={emailEnvelope}
            marginBottom={isLandscapeView ? '0.5rem' : '1rem'}
            width={smallScreen ? '85vw' : '45vw'}
            minWidth='300px'
            name='login-email-input'
            label='Email'
            type='text'
            placeholder='user@example.com'
            onChange={(e) => setUser({ ...user, username: e.target.value })}
          />
          <Input
            icon={passwordLock}
            marginBottom={isLandscapeView ? '0.5rem' : '1rem'}
            width={smallScreen ? '85vw' : '45vw'}
            minWidth='300px'
            name='login-password-input'
            label='Password'
            type='password'
            placeholder='Password'
            onChange={(e) => setUser({ ...user, password: e.target.value })}
          />
          <Button width='85vw' marginTop={isLandscapeView ? '0.5rem' : '1rem'} maxWidth='275px' type='submit'>
            Login
          </Button>
        </LoginForm>
      </Flex>
    </Flex>
  );
};

export default ResponsiveLogin;
